<template>
  <SlideMenu class="step-menu" :class="!showActiveStyle && 'hide-cover-step'" :activeIndex="showActiveStyle ? activeIndex : (stepMenuList.length - 1)">
    <div
      v-for="(item, index) in stepMenuList"
      class="step-menu-item"
      :key="item.stepType"
      :class="index === activeIndex && showActiveStyle && 'is-active'"
      @click="handleStepChange(item, index)"
    >
      <div v-show="!item.hiddenTail" class="step-tail" :class="getTailType(item, index)">
      </div>
      <div class="step-node" :class="getNodeType(item, index)">
        <i class="node-icon" :class="getNodeIconClass(item, index)"></i>
      </div>
      <div class="step-icon">
        <i :class="item.iconClass"></i>
      </div>
      <div class="step-name">{{ getMenuItemLabel(item, index) }}</div>
    </div>
  </SlideMenu>
</template>

<script>
import { NODE_TYPE, TAIL_TYPE } from '@/constant/stepMenu'
import SlideMenu from './slideMenu.vue'
import _ from 'lodash'

// const menuItem = {
//   label: '',
//   labelI18nKey: '',
//   iconClass: '',
//   hiddenTail: false,
//   tailType: TAIL_TYPE.LINE,
//   nodeType: NODE_TYPE.PENDING
// }

export default {
  components: {
    SlideMenu
  },
  model: {
    prop: 'activeIndex',
    event: 'change'
  },
  props: {
    activeIndex: {
      type: Number,
      required: true
    },
    showActiveStyle: {
      type: Boolean,
      default: true
    },
    stepMenuList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    getTailType (menuItem) {
      let tailType = TAIL_TYPE.LINE
      if (menuItem.hasOwnProperty('tailType')) {
        tailType = menuItem.tailType
      }
      return _.find(TAIL_TYPE, tailType) || TAIL_TYPE.LINE
    },
    getNodeType (menuItem, index) {
      let nodeType = menuItem.nodeType
      if (!this.showActiveStyle) {
        nodeType = NODE_TYPE.AVAILABLE
      } else if (!nodeType) {
        nodeType = index < this.activeIndex ? NODE_TYPE.AVAILABLE : index === this.activeIndex ? NODE_TYPE.PROCESSING : ''
      }
      return nodeType || NODE_TYPE.PENDING
    },
    getMenuItemLabel (menuItem) {
      if (menuItem.hasOwnProperty('label')) {
        return menuItem.label
      } else if (menuItem.hasOwnProperty('labelI18nKey')) {
        return this.$t(menuItem.labelI18nKey)
      } else {
        return ''
      }
    },
    getNodeIconClass (menuItem, index) {
      let nodeType = menuItem.nodeType
      if (!this.showActiveStyle) {
        nodeType = NODE_TYPE.AVAILABLE
      } else if (!nodeType) {
        nodeType = index < this.activeIndex ? NODE_TYPE.AVAILABLE : index === this.activeIndex ? NODE_TYPE.PROCESSING : ''
      }
      if (nodeType === NODE_TYPE.AVAILABLE) {
        return 'el-icon-success'
      } else if (nodeType === NODE_TYPE.PROCESSING) {
        return 'el-icon-more'
      } else {
        return ''
      }
    },
    handleStepChange (stepItem, index) {
      this.$emit('change', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.step-menu {
  &.slide-menu {
    &.hide-cover-step ::v-deep {
      .active-menu-item-cover {
        .step-menu-item {
          .step-name {
            color: transparent;
          }
        }
      }
    }

    ::v-deep {
      .active-menu-item-cover {
        height: 50px;
        border-radius: 5px;
        background-color: #f7f7f7;
      }
    }

    .active-slide-menu {
      .step-menu-item {
        .step-name, .step-icon {
          color: inherit;
        }
      }
    }
  }

  .step-menu-item {
    display: flex;
    height: 50px;
    margin-bottom: 15px;
    padding: 15px 25px;
    border-radius: 5px;
    align-items: center;
    cursor: pointer;
    position: relative;

    .step-icon {
      width: 22px;
      color: #ffffff;

      i {
        font-size: 22px;
      }
    }

    .step-name {
      margin-left: 40px;
      vertical-align: middle;
      color: #ffffff;
    }

    .step-tail {
      height: 100%;
      position: absolute;

      &.line {
        top: 15px;
        left: 64px;
        padding-bottom: 15px;
        border-left: 2px solid #9c9c9c;
        box-sizing: content-box;
      }

      &.arrow {
      }
    }

    &:last-child {
      .step-tail {
        display: none;
        .tail-icon {
          color: #14a965;
          font-size: 24px;
        }
      }
    }

    .step-node {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      line-height: 1;
      color: #ffffff;
      background-color: #9c9c9c;
      transform: translate(-50%, -50%);
      position: absolute;
      top: 50%;
      left: 65px;

      &.available {
        background-color: #ffffff;
        color: #14a965;

        .node-icon {
          font-size: 24px;

          &::before {
            display: block;
            margin-top: -2px;
            margin-left: -2px;
          }
        }
      }

      &.processing {
        .node-icon {
          color: #ffffff;
          font-size: 16px;

          &::before {
            display: block;
            margin-top: 2px;
            margin-left: 2px;
          }
        }
      }

      &.pending {
        padding: 4px;

        .node-icon {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background-color: #ffffff;
        }
      }
    }
  }
}
</style>
